<div class="db-optimize-with-booster-pro" id="db-optimize-with-booster-pro">
    <div class="db-optimize-with-booster-pro-title" *ngIf="!showPercentOffer">Try 10Web Booster Pro<br/> optimization for 7 days</div>
    <div class="db-optimize-with-booster-pro-title" *ngIf="showPercentOffer">Automatic optimization with Booster Pro:</div>
    <div class="db-optimize-with-booster-pro-items">
        <div class="db-optimize-with-booster-pro-item" *ngFor="let item of items">
            <div class="db-with-diamond">
                <i class="db-icon db-icon-ds-diamond"></i>
                <span>{{item.title}}</span>
            </div>
            <ng-container *ngIf="item.subFeatures">
                <div class="db-without-diamond" *ngFor="let subFeature of item.subFeatures">
                    <i class="db-icon db-icon-ds-dot"></i>
                    <span>{{subFeature}}</span>
                </div>
            </ng-container>
        </div>
    </div>
  <!--  <hr>
    <p>Included in Booster Pro</p>
    <div class="db-with-diamond db-last-diamond">
        <i class="db-icon db-icon-ds-diamond"></i>
        <span>Hosting for faster backend</span>
    </div>-->
    <div class="db-optimize-with-booster-pro-footer">
        <button class="ds-btn-outline-green ds-btn-m" (click)="redirectToBoosterPro()"><span>{{showPercentOffer ? 'Upgrade' : ('text_tryForFree' | dbText | lowerCaseSpecificWords)}}</span></button>
    </div>
</div>
